import { render, staticRenderFns } from "./EmailVerified.vue?vue&type=template&id=568db44b&"
import script from "./EmailVerified.vue?vue&type=script&lang=js&"
export * from "./EmailVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmailVerified.vue"
export default component.exports